// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeBlockRemoveBody = {
  blockedAccountId: string;
};

export type typeBlockRemoveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isBlocked: boolean };
};

export type typeBlockRemoveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeBlockRemoveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeBlockRemoveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaBlockRemoveBody = {
  type: "object",
  properties: {
    blockedAccountId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["blockedAccountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createBlockRemove(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaBlockRemoveBody);
  }

  return async function postBlockRemove(
    payload: typeBlockRemoveBody,
  ): Promise<typeBlockRemoveOutput200 | typeBlockRemoveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postBlockRemove" failed before calling the network. #22054c4c621c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#22054c4c621c" },
        },
        data: null,
      } as typeBlockRemoveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/block/remove`,
      httpMethod: "POST",
      options,
    })) as typeBlockRemoveOutput200 | typeBlockRemoveOutput400;
  };
}
